export default "__VITE_ASSET__$MRsmPPI__"